//React
import React from 'react'

//Components
import FeatureIcon from './featureIcon'

const formatDescription = descriptionText => (
  <React.Fragment>
    {descriptionText.split('\n').map((line, i) => (
      <span key={i}>
        {line}
        <br />
      </span>
    ))}
  </React.Fragment>
)

const Snippet = props => (
  <div
    class={
      props.featureData.bgcolor ? `bg-${props.featureData.bgcolor}` : 'bg-sky-6'
    }
  >
    <div class="container container-feature-quad">
      <h3
        class={`text-center mb-4 ${
          props.featureData.titlecolor
            ? props.featureData.titlecolor
            : 'white-1'
        }`}
      >
        {props.featureData.title}
      </h3>
      {/* TRIO MODE  */}
      {props.featureData.mode === 'trio' ? (
        <div class="row d-flex flex-row align-items-stretch justify-content-center">
          {props.featureData.rowdata.map((item, i) =>
            item.rowdata.map((element, j) => (
              <div
                class={`col-md-3 about-feature bg-${
                  element.colbgcolor ? element.colbgcolor : 'white-1'
                }`}
              >
                <div class="about-feature-body d-flex align-items-center justify-content-start">
                  <div class="my-2">
                    <FeatureIcon
                      context={element.iconname}
                      title="Chatbot"
                      simple
                      color={item.rowbgcolor}
                    />
                  </div>

                  {/* <FaLayerGroup
                          style={{
                            color: "#ffffff",
                            fontSize: 34,
                            opacity: 0.8,
                          }}
                        /> */}
                  {element.title ? (
                    <h4 class="pt-2 text-center">{element.title}</h4>
                  ) : null}

                  <p class="p-2 text-center">{element.description}</p>
                </div>
              </div>
            ))
          )}
        </div>
      ) : null}

      {/* QUAD MODE  */}

      {!props.featureData.mode || props.featureData.mode === 'quad'
        ? props.featureData.rowdata.map((item, i) => (
            <div class="row d-flex flex-row align-items-stretch justify-content-center text-center">
              {item.rowdata.map((element, j) => (
                <div
                  class={`col-md-4 about-feature bg-${item.rowbgcolor}-${j +
                    1}`}
                >
                  <div class="about-feature-body d-flex align-items-center justify-content-start">
                    <div class="my-2">
                      <FeatureIcon
                        context={element.iconname}
                        title="Chatbot"
                        simple
                        color={item.rowbgcolor}
                      />
                    </div>

                    {/* <FaLayerGroup
                  style={{
                    color: "#ffffff",
                    fontSize: 34,
                    opacity: 0.8,
                  }}
                /> */}
                    {element.title ? (
                      <h4 class="pt-2 text-center">{element.title}</h4>
                    ) : null}
                    <p class="p-2">{element.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ))
        : null}
    </div>
  </div>
)

export default Snippet
